import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { AlertCircleIcon, BriefcaseIcon, LayoutDashboardIcon, LogOutIcon, SettingsIcon, UsersIcon } from 'lucide-react';
import { useAdminData } from '../../contexts/AdminDataContext';
import { company } from '../../data/site';
const nav = [{
  label: 'Overblik',
  to: '/admin',
  icon: LayoutDashboardIcon,
  end: true
}, {
  label: 'Sager',
  to: '/admin/sager',
  icon: BriefcaseIcon,
  end: false
}, {
  label: 'Kunder',
  to: '/admin/kunder',
  icon: UsersIcon,
  end: false
}, {
  label: 'Indstillinger',
  to: '/admin/indstillinger',
  icon: SettingsIcon,
  end: false
}];
export function AdminShell() {
  const {
    logout,
    storageError
  } = useAdminData();
  const navigate = useNavigate();
  return <div className="flex min-h-screen w-full bg-canvas" data-id="element-27" data-mp="249n9hc2h0f2p">
      <aside className="hidden w-56 shrink-0 flex-col border-r border-line bg-white lg:flex" data-id="element-28" data-mp="nsrdkibc8atn">
        <div className="px-6 py-6" data-id="element-29" data-mp="storujt88kpv">
          <img src={company.logoWide} alt="LYKKEVÆRK" className="h-9 w-auto" data-id="element-30" data-mp="sqkjrbcn54tx" />
          <p className="mt-2 text-xs uppercase tracking-[0.18em] text-ink-muted" data-id="element-31" data-mp="30u0afwvsktgh">Admin</p>
        </div>
        <nav aria-label="Adminnavigation" className="flex flex-col gap-1 px-3" data-id="element-32" data-mp="2vvykcrzy7tvi">
          {nav.map(item => <NavLink key={item.to} to={item.to} end={item.end} className={({
          isActive
        }) => `inline-flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm transition-colors duration-200 ease-smooth ${isActive ? 'bg-ink text-white' : 'text-ink-soft hover:bg-canvas hover:text-ink'}`} data-id="element-33" data-mp="3apl67da9oxhs">
              <item.icon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-34" data-mp="3oj2oyvv4q66r" />
              {item.label}
            </NavLink>)}
        </nav>
        <button type="button" onClick={() => {
        logout();
        navigate('/admin/login');
      }} className="mx-3 mb-6 mt-auto inline-flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm text-ink-soft transition-colors duration-200 ease-smooth hover:bg-canvas hover:text-ink" data-id="element-35" data-mp="6dzfkyy4r80j">
          <LogOutIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-36" data-mp="jd8kx6p7x7nq" />
          Log ud
        </button>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col" data-id="element-37" data-mp="o479etkd1c22">
        <header className="sticky top-0 z-40 border-b border-line bg-white/95 px-5 py-3 backdrop-blur lg:hidden" data-id="element-38" data-mp="o5s2eer10mxt">
          <div className="flex items-center justify-between" data-id="element-39" data-mp="x4na5v9py538">
            <div data-id="element-40" data-mp="x2sm4835hwux">
              <img src={company.logoWide} alt="LYKKEVÆRK" className="h-8 w-auto" data-id="element-41" data-mp="x6gfn78lij9n" />
              <p className="mt-1 text-[10px] uppercase tracking-[0.18em] text-ink-muted" data-id="element-42" data-mp="124hvljaq62gw">Admin</p>
            </div>
            <button type="button" onClick={() => {
            logout();
            navigate('/admin/login');
          }} className="inline-flex h-9 items-center gap-2 rounded-full border border-line px-3.5 text-sm text-ink-soft" data-id="element-43" data-mp="170gu3zprp0v1">
              <LogOutIcon className="h-4 w-4" aria-hidden="true" data-id="element-44" data-mp="1q0wgocesovbl" />
              Log ud
            </button>
          </div>
        </header>

        {storageError && <p role="alert" className="flex items-start gap-2 border-b border-danger/30 bg-danger/10 px-5 py-3 text-sm text-danger md:px-8" data-id="element-45" data-mp="1h79looievw3g">
            <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-46" data-mp="28y7b9jphf0kp" />
            Dine seneste ændringer kunne ikke gemmes i browseren. Lagringen er sandsynligvis fuld — prøv at
            slette store billeder fra gamle sager.
          </p>}

        <main className="min-w-0 flex-1 pb-24 lg:pb-0" data-id="element-47" data-mp="1uy4wi6ch0n9o">
          <Outlet data-id="element-48" data-mp="1uxms2mfnn2qo" />
        </main>

        <nav aria-label="Adminnavigation" className="fixed bottom-0 left-0 right-0 z-40 flex border-t border-line bg-white/95 backdrop-blur lg:hidden" data-id="element-49" data-mp="oi2optylvekb">
          {nav.map(item => <NavLink key={item.to} to={item.to} end={item.end} className={({
          isActive
        }) => `flex flex-1 flex-col items-center gap-1 py-3 text-[11px] transition-colors duration-200 ease-smooth ${isActive ? 'text-accent' : 'text-ink-muted'}`} data-id="element-50" data-mp="27fxk45wm7da7">
              <item.icon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-51" data-mp="23bpzajta2hh9" />
              {item.label}
            </NavLink>)}
        </nav>
      </div>
    </div>;
}